export const en = {
    "k_30d87fe6": "Wait for the page slice to complete rendering",
    "k_bf14b9ec": "This method can ensure that subsequent logical page slices are rendered complete",
    "k_45ec49bc": "The page type added is wrong!",
    "k_373f9513": "Please preview it on the custom domain name product end",
    "k_7f03ca25": "Test version failed to load",
    "k_c33419b7": "Preparing the AI page development environment",
    "k_b81aa179": "Stable version (stable)",
    "k_1c51e86f": "Current page address:{arg_0}",
    "k_8d2a847": "Error time:{arg_0}",
    "k_8014ef31": "Copy to clipboard",
    "k_d08ece71": "Select editor version",
    "k_49d920f9": "Please try selecting a new version, or copy the following information and contact the assistant:",
    "k_7bcb1437": "Click to copy",
    "k_88d1ef68": "Invalid",
    "k_3c12d276": "After selection, editor resources will be reloaded and invalid versions will be disabled",
    "k_ff04ee3d": "[customRequire]{arg_0} is not implemented",
    "k_c4e7c58e": "Unable to find configuration for data source \"{arg_0}\"",
    "k_9343d92b": "Don't have permission to call, click",
    "k_a25ae439": "Global context",
    "k_f6f2e934": "Pass on the current page",
    "k_deb1b3a5": "Get embedded instances",
    "k_35d819a0": "Embedded examples pass",
    "k_bc3d436d": "Get the current page",
    "k_c8dc68f3": "No interface is configured for this data source",
    "k_ef06983": "Generate default parameters",
    "k_80c1f0c8": "Generating batch request parameters",
    "k_91588be6": "View the document",
    "k_2aff46c6": "This data source supports custom data source methods, and it is recommended to use custom data source methods to make requests for a better experience",
    "k_31490b4d": "Failed to obtain collection information",
    "k_19a0e4b5": "Message sender",
    "k_305e5cb7": "Platform provides",
    "k_b257ebd6": "There is no enterprise WeChat application provided by the platform",
    "k_9808dfd3": "Customizable enterprise WeChat application",
    "k_179e3623": "Dynamically set",
    "k_45852bd6": "Fixedly arranged",
    "k_5023cf7a": "View details",
    "k_d9fb7e1e": "Text card",
    "k_11c00bab": "Text content",
    "k_6fd72d07": "Markdown content",
    "k_5e1d3473": "Supported markdown syntax",
    "k_428000f6": "You can support line breaks and subsets of mark syntax, such as: [View](http://x.y.z), length limit of 2048",
    "k_eee3f94b": "Card title, length limit 128",
    "k_68a8d96e": "Card content, length limit 512",
    "k_905be975": "Click on the link that the card jumps, the length limit is 2048",
    "k_f570ff32": "Button text",
    "k_cd0a617c": "Length Limit 4",
    "k_339c3ea3": "The current project has no pages, and the online components in the navigation bar cannot preview scenarios using data sources",
    "k_4f054dd5": "You can support line breaks and hyperlinks, such as: View &lt;a href='http://x.y.z';&gt; details</a>, length limit 2048",
    "k_75a2df0a": "Multilingual translation",
    "k_bc6055e1": "[ProjectNameHandler] Element with data-i18n=\"project-name\" not found",
    "k_28aa4883": "Project dependence information",
    "k_51860ac6": "Modify the version number and save it to update the version-changes here are project-level",
    "k_4ebe6540": "Please note:",
    "k_8c3fe156": "You cannot add/remove dependencies here, you need to add or remove references from the source code to take effect",
    "k_d509bfbb": "Reduction",
    "k_a0efafaf": "Update dependency",
    "k_fc2ddc43": "Simplified Chinese",
    "k_91fcdff4": "Current branch",
    "k_a0c92d39": "Target branch",
    "k_ecc03546": "Loading AI project...",
    "k_6be6212c": "Failed to load AI project: {arg_0}"
};
